import { useState, useEffect } from 'react';
import { apiPost } from 'apis/api';
import { useLocation } from 'react-router-dom';

import 'assets/css/notice.scss';
import TopImage from 'components/common/topImage';
import PageTab from 'components/common/pageTab';

import {pageMenuTabList06} from 'types/common';

export default function NoticeView() {
  const location = useLocation();
  const noticeIdx = location.state.noticeIdx;
  const [noticeData, setNoticeData] = useState<any>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiPost('/board/getNoticeData', { intNoticeIdx : noticeIdx }) as { data: any };
        console.log(response)
        setNoticeData(response);
        
      } catch (error) {
        console.error('Error fetching notice:', error);
      }
    };

    fetchData();
  }, [noticeIdx]);

  return (
    <div className="page_content">
      <TopImage imgUrl="https://img.chunhomall.com/images/brand_site/notice-hero_1920x1080.jpg.jpg" imgText="공지사항" textcolor="#333"></TopImage>
      <PageTab props={pageMenuTabList06}></PageTab>
      <div className="container">

        <div className="container-title">
          고객님들의 의견을 존중합니다.<br/>
          항상 내가족을 생각하면서 만들겠습니다.
        </div>
      </div>
      <div className="notice">
        <div className='notice-view container'>
          <div className='notice-view-inner'>
            {noticeData && (
              <>
                <div className='notice-header'>
                  <div className='notice-title'>{noticeData.BoardTitle}</div>
                  <div className='notice-date'>{noticeData.BoardType === '1' ? noticeData.BoardRegDate : ''}</div>
                </div>
                {noticeData.BoardContent && (
                  <div className='notice-content' dangerouslySetInnerHTML={{ __html: noticeData.BoardContent }} />
                )}
              </>
            )}
            <div className='btn-area'>
              <button className='btn' onClick={() => window.history.back()}>목록</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
